<template>
    <IndexBase @auth="onAuth($event)" action="Index" controller="MainData"></IndexBase>

    <Card>
        <template #title>
            <Toolbar>
                <template #left>
                    <div class="p-card-title">
                        {{ $t('maindata') }}
                    </div>
                </template>
                <template #right>
                    <!-- <div class="p-card-title" style="margin-top:10px;">
                        <Button v-show="canUpload" label="Upload" icon="pi pi-upload" class="p-button-success p-button-sm"
                            @click="importFile()" style="margin-left:5px;" />
                    </div> -->
                </template>
            </Toolbar>
        </template>
        <template #content>
            <DataTable ref="dt" responsiveLayout="scroll" class="p-datatable-sm" filterDisplay="row" sortMode="multiple" removableSort
                v-model:expandedRows="expandedRows"
                stateStorage="local"
                :stateKey="stateKey"
                :value="dataModel" :loading="!dataModel || loading"
                :paginator="true"
                :rows="10"
                :lazy="true"
                v-model:first="this.start"
                @rowExpand="onRowExpand"
                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                :rowsPerPageOptions="[10, 20, 50]" currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                @state-restore="onStateRestore($event)"
                @page="onPage($event)"
                @sort="onSort($event)"
                @filter="onFilter($event)"
                @update:selection="onSelect($event)"
                @row-dblclick="onRowDoubleClick"
                v-model:filters="filters"
                :totalRecords="totalRecords"
                dataKey="Id" :metaKeySelection="false">
                
                <Column :exportable="false" :sortable="false" headerStyle="white-space:nowrap">
                    <template #header>
                        <!-- this.$store.getters.getJobPosition.includes(this.$UserLevel.ADMIN_PROJECT) -->
                        <Button v-show="canCreate || (this.$store.getters.getIsAdmin)" :label="$t('create')" icon="pi pi-plus"
                            class="p-button-primary p-button-sm" @click="editor(this.$FORM_MODE_CREATE, 0)" />
                            
                    </template>
                    <template #filter>
                        <Button :label="$t('clear')" icon="pi pi-filter-slash"
                            class="p-button-outlined p-button-primary p-button-sm" @click="clearFilter" :badge="filterBadge"
                            badgeClass="p-badge-danger" />
                    </template>
                    <template #body="dataModel">
                        <Button icon="pi pi-search" v-show="canView" class="p-button-rounded p-button-info mr-2 p-button-sm"
                            @click="editor(this.$FORM_MODE_VIEW, dataModel.data.Id)" />
                            <!-- !dataModel.data.hide_edit  v-if="(dataModel.data.Status != this.$APPROVAL_STATUS.WAITING_FOR_APPROVAL)"-->
                            <Button icon="pi pi-pencil" v-show="canEdit && dataModel.data.Is_Deleted == 'N'"
                            class="p-button-rounded p-button-success mr-2 p-button-sm"
                            @click="editor(this.$FORM_MODE_EDIT, dataModel.data.Id)" />
                        <Button icon="pi pi-trash" v-show="canDelete && dataModel.data.Is_Deleted == 'N'" v-if="(dataModel.data.Status != this.$APPROVAL_STATUS.WAITING_FOR_APPROVAL)"
                            class="p-button-rounded p-button-danger mr-2 p-button-sm"
                            @click="editor(this.$FORM_MODE_DELETE, dataModel.data.Id)" />
                    </template>
                </Column>

                <!-- <Column field="Company" :header="$t('company')" :sortable="true" :expander="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" :placeholder="$t('company')" v-if="filterModel"
                            v-model="filterModel.value" @keydown.enter="filterCallback()"
                            class="p-column-filter p-inputtext-sm" />
                    </template>
                </Column> -->

                <Column field="Status" :header="$t('status')" :sortable="true" :expander="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" :placeholder="$t('status')" v-if="filterModel"
                            v-model="filterModel.value" @keydown.enter="filterCallback()"
                            class="p-column-filter p-inputtext-sm" />
                    </template>
                </Column>

                <Column field="No_Wo" :header="$t('no_wo')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" :placeholder="$t('no_wo')" v-if="filterModel"
                            v-model="filterModel.value" @keydown.enter="filterCallback()"
                            class="p-column-filter p-inputtext-sm" />
                    </template>
                </Column>
                <Column field="Wo_Number_Main" :header="$t('Link_Main_Wo')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" :placeholder="$t('Link_Main_Wo')" v-if="filterModel"
                            v-model="filterModel.value" @keydown.enter="filterCallback()"
                            class="p-column-filter p-inputtext-sm" />
                    </template>
                </Column>
                <Column field="SPO_Item" :header="$t('no_spo')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" :placeholder="$t('no_spo')" v-if="filterModel"
                            v-model="filterModel.value" @keydown.enter="filterCallback()"
                            class="p-column-filter p-inputtext-sm" />
                    </template>
                </Column>
                <Column field="Company_Contractor" :header="$t('company_contractor')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" :placeholder="$t('company_contractor')" v-if="filterModel"
                            v-model="filterModel.value" @keydown.enter="filterCallback()"
                            class="p-column-filter p-inputtext-sm" />
                    </template>
                </Column>
                
                <Column field="project_manager" :header="$t('project_manager')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" :placeholder="$t('project_manager')" v-if="filterModel"
                            v-model="filterModel.value" @keydown.enter="filterCallback()"
                            class="p-column-filter p-inputtext-sm" />
                    </template>
                </Column>


                
                
                <Column field="Budget" :header="$t('budget')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" :placeholder="$t('budget')" v-if="filterModel"
                            v-model="filterModel.value" @keydown.enter="filterCallback()"
                            class="p-column-filter p-inputtext-sm" />
                    </template>
                </Column>
                
                
                <Column field="Deskripsi_Pekerjaan" :header="$t('job_desc')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" :placeholder="$t('job_desc')" v-if="filterModel"
                            v-model="filterModel.value" @keydown.enter="filterCallback()"
                            class="p-column-filter p-inputtext-sm" />
                    </template>
                </Column>
                
                <!-- <Column field="Area" :header="$t('area')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" :placeholder="$t('area')" v-if="filterModel"
                            v-model="filterModel.value" @keydown.enter="filterCallback()"
                            class="p-column-filter p-inputtext-sm" />
                    </template>
                </Column> -->
                
                <!-- <Column field="Type" :header="$t('type')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" :placeholder="$t('type')" v-if="filterModel"
                            v-model="filterModel.value" @keydown.enter="filterCallback()"
                            class="p-column-filter p-inputtext-sm" />
                    </template>
                </Column> -->



                <Column field="location" :header="$t('location')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" :placeholder="$t('location')" v-if="filterModel"
                            v-model="filterModel.value" @keydown.enter="filterCallback()"
                            class="p-column-filter p-inputtext-sm" />
                    </template>
                </Column>

                <Column field="Created_Date" :header="$t('created_date')" dataType="date" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <DatePicker :placeholder="$t('created_date')" dateFormat="dd/mm/yyyy" inputMask="99/99/9999"
                            momentFormat="DD/MM/YYYY" class="p-column-filter p-inputtext-sm" v-if="filterModel"
                            v-model="filterModel.value" @keydown.enter="filterCallback()" @date-select="filterCallback()" />
                    </template>
                    <template #body="{ data }">
                        {{ this.$formatDateTime(data.Created_Date) }}
                    </template>
                </Column>
                <Column field="Created_By" :header="$t('created_by')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" v-if="filterModel" v-model="filterModel.value"
                            @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"
                            :placeholder="$t('created_by')" />
                    </template>
                </Column>
                <Column field="Edited_Date" :header="$t('edited_date')" dataType="date" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <DatePicker dateFormat="dd/mm/yyyy" inputMask="99/99/9999" momentFormat="DD/MM/YYYY"
                            class="p-column-filter p-inputtext-sm" v-if="filterModel" v-model="filterModel.value"
                            @keydown.enter="filterCallback()" 
                            :placeholder="$t('edited_date')"
                            @date-select="filterCallback()" />
                    </template>
                    <template #body="{ data }">
                        {{ this.$formatDateTime(data.Edited_Date) }}
                    </template>
                </Column>
                <Column field="Edited_By" :header="$t('edited_by')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" v-if="filterModel" v-model="filterModel.value"
                            @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"
                            :placeholder="$t('edited_by')" />
                    </template>
                </Column>
                <Column field="Is_Deleted" :header="$t('is_deleted')" dataType="date" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <YNSelect :placeholder="$t('is_deleted')" :useBinary="true" v-if="filterModel"
                            v-model="filterModel.value" @change="filterCallback()" />
                    </template>
                </Column>
                <Column field="Deleted_Date" :header="$t('deleted_date')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <DatePicker dateFormat="dd/mm/yyyy" inputMask="99/99/9999" momentFormat="DD/MM/YYYY"
                            class="p-column-filter p-inputtext-sm" v-if="filterModel" v-model="filterModel.value"
                            @keydown.enter="filterCallback()" @date-select="filterCallback()"
                            :placeholder="$t('deleted_date')" />
                    </template>
                    <template #body="{ data }">
                        {{ this.$formatDateTime(data.Deleted_Date) }}
                    </template>
                </Column>
                <Column field="Deleted_By" :header="$t('deleted_by')" dataType="date" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" v-if="filterModel" v-model="filterModel.value"
                            @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"
                            :placeholder="$t('deleted_by')" />
                    </template>
                </Column>
                <template #expansion="slotProps">
                    <div class="orders-subtable">
                        <DataTable :value="slotProps.data.Details" class="p-datatable-sm editable-cells-table" responsiveLayout="scroll">
                            <Column field="No" :header="$t('no')" key="Id" style="width: 4%;">
                                <template #body="slotProps">
                                    <div class="p-fluid">
                                       {{ slotProps.index + 1 }} 
                                    </div>
                                </template>
                            </Column>
                            <Column field="Doc_Type" :header="$t('doc_type')"  style="width: 15%;">
                                <template #body="data">
                                    <span  v-if="data.data.Doc_Type == this.$TypeDocument.MC0">{{ this.$FullNameDoc.MC0 }}</span>
                                    <span  v-else-if="data.data.Doc_Type == this.$TypeDocument.ADDENDUM_MC0">{{ this.$FullNameDoc.ADDENDUM_MC0 }}</span>
                                    <span  v-else-if="data.data.Doc_Type == this.$TypeDocument.BA_IK_WITH_SPO">{{ this.$FullNameDoc.BA_IK_WITH_SPO }}</span>
                                    <span  v-else-if="data.data.Doc_Type == this.$TypeDocument.BA_IK_WITHOUT_SPO">{{ this.$FullNameDoc.BA_IK_WITHOUT_SPO }}</span>
                                    <span  v-else-if="data.data.Doc_Type == this.$TypeDocument.KOM">{{ this.$FullNameDoc.KOM }}</span>
                                    <span  v-else-if="data.data.Doc_Type == this.$TypeDocument.PROGRESS_TERMIN">{{ this.$FullNameDoc.PROGRESS_TERMIN }}</span>
                                    <span  v-else-if="data.data.Doc_Type == this.$TypeDocument.DELAY">{{ this.$FullNameDoc.DELAY }}</span>
                                    <span  v-else-if="data.data.Doc_Type == this.$TypeDocument.MC_BETWEEN">{{ this.$FullNameDoc.MC_BETWEEN }}</span>
                                    <span  v-else-if="data.data.Doc_Type == this.$TypeDocument.ADDENDUM_MC_BETWEEN">{{ this.$FullNameDoc.ADDENDUM_MC_BETWEEN }}</span>
                                    <span  v-else-if="data.data.Doc_Type == this.$TypeDocument.MC100">{{ this.$FullNameDoc.MC100 }}</span>
                                    <span  v-else-if="data.data.Doc_Type == this.$TypeDocument.ADDENDUM_MC100">{{ this.$FullNameDoc.ADDENDUM_MC100 }}</span>
                                    <span  v-else-if="data.data.Doc_Type == this.$TypeDocument.PENALTY">{{ this.$FullNameDoc.PENALTY }}</span>
                                    <span  v-else-if="data.data.Doc_Type == this.$TypeDocument.PROGRESS_FINAL">{{ this.$FullNameDoc.PROGRESS_FINAL }}</span>
                                    <span  v-else-if="data.data.Doc_Type == this.$TypeDocument.ADDENDUM">{{ this.$FullNameDoc.ADDENDUM }}</span>
                                    <span  v-else-if="data.data.Doc_Type == this.$TypeDocument.KOM_QC">{{ this.$FullNameDoc.KOM_QC }}</span>
                                    <span  v-else-if="data.data.Doc_Type == this.$TypeDocument.BAST_TERMIN">{{ this.$FullNameDoc.BAST_TERMIN }}</span>
                                    <span  v-else-if="data.data.Doc_Type == this.$TypeDocument.FINAL_QC">{{ this.$FullNameDoc.FINAL_QC }}</span>
                                    <span  v-else-if="data.data.Doc_Type == this.$TypeDocument.BAST_FINAL">{{ this.$FullNameDoc.BAST_FINAL }}</span>
                                    <span  v-else-if="data.data.Doc_Type == this.$TypeDocument.BAST_RETENSI">{{ this.$FullNameDoc.BAST_RETENSI }}</span>
                                </template>
                            </Column>
                            <Column field="Process" :header="$t('process')" style="width: 8%;">
                                <template #body="data">
                                    <div class="flex flex-wrap gap-2">
                                        <Button class="p-button-rounded p-button-primary mr-2 p-button-sm" 
                                        :disabled="(data.data.Is_Disabled) || (data.data.Process == this.$MAIN_DATA_STATUS.YA || data.data.Process == this.$MAIN_DATA_STATUS.TIDAK) || !listTransactionCreate.includes(data.data.Doc_Type)"
                                        v-if="canView" @click="gotoCreate(data.data,this.$FORM_MODE_CREATE,slotProps.data.Id,0)"> 
                                        <span style="color: red" v-if="data.data.Process == this.$MAIN_DATA_STATUS.YA">Ya</span>
                                        <span v-else>Ya</span>
                                        </Button>
                                        <!-- (data.data.Doc_Type == this.$TypeDocument.BA_IK_WITH_SPO || data.data.Doc_Type == this.$TypeDocument.BA_IK_WITHOUT_SPO || data.data.Doc_Type == this.$TypeDocument.KOM)  -->
                                        <Button label="Tidak" class="p-button-rounded p-button-primary p-button-sm" severity="secondary" 
                                        :disabled="data.data.Is_Disabled || (data.data.Keterangan != null && data.data.Keterangan != this.$DOCUMENT_STATUS.DRAFT && data.data.Keterangan != this.$DOCUMENT_STATUS.NO_NEED_APPROVAL) || (data.data.Process == this.$MAIN_DATA_STATUS.YA || data.data.Process == this.$MAIN_DATA_STATUS.TIDAK) || (data.data.Status == this.$MAIN_DATA_STATUS.Require) || !listTransactionCreate.includes(data.data.Doc_Type)"
                                        v-if="canView" @click="confirmProcess(data.data, this.$MAIN_DATA_STATUS.TIDAK, this.$MAIN_DATA_STATUS.TIDAK, $event)">
                                        <span style="color: red" v-if="data.data.Process == this.$MAIN_DATA_STATUS.TIDAK">Tidak</span>
                                        <span v-else>Tidak</span>
                                        </Button>
                                        <ConfirmPopup></ConfirmPopup>
                                    </div>
                                </template>
                            </Column>
                            <Column field="Action" :header="$t('action')" style="width: 7%;">
                                <template #body="data">
                                    <div class="flex flex-wrap">
                                        <Button icon="pi pi-undo" class="p-button-rounded p-button-success mr-2 p-button-sm" v-if="(data.data.Status != this.$APPROVAL_STATUS.WAITING_FOR_APPROVAL && data.data.Status != this.$MAIN_DATA_STATUS.TIDAK_TERSEDIA)"
                                           v-show="canCreate" 
                                           :disabled="!data.data.canReverse"
                                           @click="confirmReverse(data.data, this.$MAIN_DATA_STATUS.YA, $event)"/>
                                        <Button icon="pi pi-pencil" class="p-button-rounded p-button-success mr-2 p-button-sm" v-if="!data.data.viewOnly && ((data.data.Keterangan != this.$APPROVAL_STATUS.WAITING_FOR_APPROVAL && data.data.Keterangan != this.$APPROVAL_STATUS.APPROVED && data.data.Keterangan != this.$APPROVAL_STATUS.REJECTED && data.data.Keterangan != this.$APPROVAL_STATUS.DONE))"
                                           v-show="canView" :disabled="(data.data.Process != this.$MAIN_DATA_STATUS.YA) || ( !listTransactionEdit.includes(data.data.Doc_Type) || ((data.data.typeAddendum == 'BAPVA' && !canEditBAPVA) || (data.data.typeAddendum == 'ADDENDUM' && !canEditAddendum) ||  (data.data.typeAddendum == 'RKTK' && !canEditRKTK))) " @click="gotoEdit(data.data,this.$FORM_MODE_EDIT,slotProps.data.Id, data.data.typeAddendum)"/>
                                        <Button icon="pi pi-search" class="p-button-rounded p-button-primary mr-2 p-button-sm" v-else
                                            v-show="canView"  :disabled="(data.data.Process != this.$MAIN_DATA_STATUS.YA) || (!listTransactionView.includes(data.data.Doc_Type) && ((data.data.typeAddendum == 'BAPVA' && !canViewBAPVA) || (data.data.typeAddendum == 'ADDENDUM' && !canViewAddendum) ||  (data.data.typeAddendum == 'RKTK' && !canViewRKTK)))" @click="gotoEdit(data.data,this.$FORM_MODE_VIEW,slotProps.data.Id, data.data.typeAddendum)"/>
                                        <Button icon="pi pi-print" class="p-button p-component p-button-icon-only p-button-rounded p-button-danger p-button-outlined" 
                                           v-show="canPrint && data.data.Doc_Type != this.$TypeDocument.KOM_QC" :disabled="(data.data.Process != this.$MAIN_DATA_STATUS.YA) || (!listTransactionPrint.includes(data.data.Doc_Type) && ((data.data.typeAddendum == 'BAPVA' && !canPrintBAPVA) || (data.data.typeAddendum == 'ADDENDUM' && !canPrintAddendum) ||  (data.data.typeAddendum == 'RKTK' && !canPrintRKTK))) && data.data.Doc_Type != this.$TypeDocument.KOM_QC" @click="generatePdf(data.data, data.data.typeAddendum)"/>
                                    </div>
                                </template>
                            </Column>
                            <!-- <Column field="Status" :header="$t('status')" style="width: 200px">
                                <template #body="data">
                                    <span v-if="data.data.Status == this.$MAIN_DATA_STATUS.TERSEDIA">Process</span>
                                    <span v-else-if="data.data.Status == this.$MAIN_DATA_STATUS.TIDAK_TERSEDIA">No Need Process</span>
                                </template>
                            </Column> -->
                            
                            <Column field="Rev" :header="$t('Rev')" style="width: 4%;"></Column>

                            <Column field="Keterangan" :header="$t('keterangan')" style="width: 8%;">
                                <template #body="data">
                                    <span v-if="data.data.Keterangan == this.$APPROVAL_STATUS.DONE"> {{ this.$APPROVAL_STATUS.FULL_APPROVAL }}</span>
                                    <span  v-else-if="data.data.Keterangan == this.$APPROVAL_STATUS.REVISED"> {{ this.$APPROVAL_STATUS.WAITING_FOR_REVISION }}</span>
                                    <span v-else> {{ data.data.Keterangan }}</span>
                                    <span v-if="data.data.Keterangan != 'CANCEL'">{{ " " + (data.data.picapprove != null ? "(" + data.data.picapprove + ")": "") }} </span>
                                </template>
                            </Column>

                               <Column :header="$t('logprocess')" style="width: 50%;">
                                <template #body="data">
                                    {{ (data.data.Action_Status ? (data.data.Action_Status +  ' - ' ) : '') +" "+ (data.data.Edited_By ? (data.data.Edited_By +  ' - ' ) : '') +" "+ (data.data.Edited_Date ? this.$formatDateTime(data.data.Edited_Date) : '')}}
                                </template>
                            </Column>

                        </DataTable>
                    </div>
                </template>
            </DataTable>
        </template>
    </Card>
</template>

<script>
import IndexBase from '../Helper/IndexBase.vue'

export default {
    name: "Contractor",
    components: {
        'IndexBase': IndexBase
    },
    data() {
        return {
            dataModel: null,
            loading: true,
            totalRecords: 0,
            start: 0,
            stateKey: this.$STATE_NAME + 'maindata-' + this.$store.getters.getUsername,
            isAdmin: this.$store.getters.getIsAdmin,
            sorts: null,
            lazyParams: {},
            filters: null,
            stateFilters: null,
            editorPath: "/MainData/Editor",
            dataUrl: "maindata/list",
            url: "maindata",
            uploadPath: "/Helper/UploadData/Company",
            canCreate: false,
            canEdit: false,
            canDelete: false,
            canView: false,
            canPrint: false,
            expandedRows: [],
            pageSize : 10,
            listTransactionCreate : [],
            listTransactionEdit : [],
            listTransactionView : [],
            listTransactionPrint : [],
            isContractor : false,
            canViewBAPVA: false,
            canViewRKTK : false,
            canViewAddendum : false,
            canEditBAPVA: false,
            canEditRKTK : false,
            canEditAddendum : false,
            canPrintBAPVA: false,
            canPrintRKTK : false,
            canPrintAddendum : false,
        }
    },
    methods: {
        confirmProcess(data, status, process, e){
            
            this.$confirm.require({
                target: e.currentTarget,
                message: 'Are you sure not to process ?',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    this.updateProcess(data, status, process);
                },
                reject: () => {

                }
            });
        },
        confirmReverse(data, process, e){
            
            this.$confirm.require({
                target: e.currentTarget,
                message: 'Are you sure you want to reverse processing?',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    this.updateReverse(data, process);
                },
                reject: () => {

                }
            });
        },
        isLastRow(index, length) 
        {

        },
        onAuth(event) {
            this.canCreate = event.canCreate;
            this.canEdit = event.canEdit;
            this.canDelete = event.canDelete;
            this.canView = event.canView;
            this.canPrint = event.canPrint;
        },
        onPage(event) {
            this.start = event.first;
            this.pageSize = event.rows;
            this.loadLazyData();
        },
        onSort(event) {
            this.sorts = event.multiSortMeta;
            this.loadLazyData();
        },
        onFilter() {
            this.loadLazyData();
        },
        onSelect(event) {
            this.selectedRow = event.data;
        },
        onRowExpand(event) {
            this.expandedRows = [];
            this.expandedRows.push(event.data);
        },
        editor(mode, id) {
            this.$router.push({ path: this.editorPath, query: { mode: mode, id: id } });
        },
        filter(mode) {
            this.$router.push({ path: this.filterPath, query: { mode: mode } });
        },
        sidebarMessage(event) {
            this.$toast.add(event);
        },
        loadLazyData() {
            this.loading = true;
            this.selectedRow = null;

            this.lazyParams = {
                start: this.start,
                pageSize : this.pageSize,
                sorts: this.dataSort,
                filters: this.dataFilter
            };

            var self = this;

            this.$axios.post(this.$API_URL + this.dataUrl, this.lazyParams)
                .then((response) => {
                    if (response.data.success) {
                        this.dataModel = response.data.data;
                        this.totalRecords = response.data.totalRecords;
                    }
                    else {
                        self.$toast.add({ severity: 'error', summary: "Error", detail: response.data.message, life: this.$DEFAULT_TIMER });
                    }
                })
                .catch(function (err) {
                    const errorMsg = err.isTimeout ? err.message : err.message;
                    self.$toast.add({ severity: 'error', summary: "Error", detail: errorMsg, life: self.$DEFAULT_TIMER });
                })
                .finally(() => {
                    self.loading = false;
                });
        },
        updateProcess(data, status, process) {
            var self = this;
          

            data.Status = status;
            data.Process = process;
            this.$axios.post(this.$API_URL  + this.url + "/process", data)
                .then((response) => {
                    if (response.data.success) {
                        //self.$emit('unblock-ui');
                        this.loadLazyData();
                        self.$toast.add({ severity: 'success', summary: "Success", detail: response.data.message, life: this.$DEFAULT_TIMER });
                        
                    }
                    else {
                        this.loadLazyData();
                        //self.$emit('unblock-ui');
                        self.$toast.add({ severity: 'error', summary: "Error", detail: response.data.message, life: this.$DEFAULT_TIMER });
                    }
                })
                .catch(function (error) {
                    //self.$emit('unblock-ui');
                    self.$toast.add({ severity: 'error', summary: "Error", detail: error, life: this.$DEFAULT_TIMER });
                });
                
        },
        updateReverse(data, process) {
            var self = this;
            data.Process = process;
            this.$axios.post(this.$API_URL  + this.url + "/reverce", data)
                .then((response) => {
                    if (response.data.success) {
                        //self.$emit('unblock-ui');
                        this.loadLazyData();
                        self.$toast.add({ severity: 'success', summary: "Success", detail: response.data.message, life: this.$DEFAULT_TIMER });
                        
                    }
                    else {
                        this.loadLazyData();
                        //self.$emit('unblock-ui');
                        self.$toast.add({ severity: 'error', summary: "Error", detail: response.data.message, life: this.$DEFAULT_TIMER });
                    }
                })
                .catch(function (error) {
                    //self.$emit('unblock-ui');
                    self.$toast.add({ severity: 'error', summary: "Error", detail: error, life: this.$DEFAULT_TIMER });
                });
                
        },
        gotoEdit(data, mode, mainid, type){
            if(data.Doc_Type == this.$TypeDocument.MC0)
            {
                this.$router.push({ path: "/MC/Editor", query: { mode: mode, mainid : mainid,id: data.Doc_MC_Id, type: this.$TypeMC.MC0 } });
            }
            else if(data.Doc_Type == this.$TypeDocument.ADDENDUM_MC0)
            {
                if(type == 'BAPVA')
                {
                    this.$router.push({ path: "/AddendumMC/EditorBAPVA", query: { mode: mode, mainid : mainid,id: data.Doc_BAPVA_Id, type: this.$TypeMC.MC0 } });
                }else if(type == 'RKTK')
                {
                    this.$router.push({ path: "/AddendumMC/EditorRKTK", query: { mode: mode, mainid : mainid,id: data.Doc_RKTK_Id, type: this.$TypeMC.MC0 } });
                }
                else if(type == 'ADDENDUM')
                {
                    this.$router.push({ path: "/AddendumMC/EditorAddendum", query: { mode: mode, mainid : mainid,id: data.Doc_MC_Addendum_Id, type: this.$TypeMC.MC0 } });
                }
            }
            else if(data.Doc_Type == this.$TypeDocument.BA_IK_WITH_SPO){
                this.$router.push({ path: "/BaWithSpo/Editor", query: { mode: mode, mainid : mainid,id: data.BAIK_With_SPO_Id } });
            }
            else if(data.Doc_Type == this.$TypeDocument.KOM){
                this.$router.push({ path: "/DocKom/Editor", query: { mode: mode, mainid : mainid,id: data.Doc_KOM_Id } });
            }
            else if(data.Doc_Type == this.$TypeDocument.PROGRESS_TERMIN){
                this.$router.push({ path: "/ProgressTermin/Editor", query: { mode: mode, mainid : mainid,id: data.Doc_Progress_Termin_Id } });
            }
            if(data.Doc_Type == this.$TypeDocument.MC_BETWEEN)
            {
                this.$router.push({ path: "/MC/Editor", query: { mode: mode, mainid : mainid,id: data.Doc_MC_Id, type: this.$TypeMC.MC_BETWEEN } });
            }
            else if(data.Doc_Type == this.$TypeDocument.ADDENDUM_MC_BETWEEN)
            {
                if(type == 'BAPVA')
                {
                    this.$router.push({ path: "/AddendumMC/EditorBAPVA", query: { mode: mode, mainid : mainid,id: data.Doc_BAPVA_Id, type: this.$TypeMC.MC_BETWEEN  } });
                }else if(type == 'RKTK')
                {
                    this.$router.push({ path: "/AddendumMC/EditorRKTK", query: { mode: mode, mainid : mainid,id: data.Doc_RKTK_Id, type: this.$TypeMC.MC_BETWEEN  } });
                }
                else if(type == 'ADDENDUM')
                {
                    this.$router.push({ path: "/AddendumMC/EditorAddendum", query: { mode: mode, mainid : mainid,id: data.Doc_MC_Addendum_Id, type: this.$TypeMC.MC_BETWEEN  } });
                }
            }
            else if(data.Doc_Type == this.$TypeDocument.MC100)
            {
                this.$router.push({ path: "/MC/Editor", query: { mode: mode, mainid : mainid,id: data.Doc_MC_Id, type: this.$TypeMC.MC100 } });
            }
            else if(data.Doc_Type == this.$TypeDocument.ADDENDUM_MC100)
            {
                if(type == 'BAPVA')
                {
                    this.$router.push({ path: "/AddendumMC/EditorBAPVA", query: { mode: mode, mainid : mainid,id: data.Doc_BAPVA_Id, type: this.$TypeMC.MC100 } });
                }else if(type == 'RKTK')
                {
                    this.$router.push({ path: "/AddendumMC/EditorRKTK", query: { mode: mode, mainid : mainid,id: data.Doc_RKTK_Id, type: this.$TypeMC.MC100  } });
                }
                else if(type == 'ADDENDUM')
                {
                    this.$router.push({ path: "/AddendumMC/EditorAddendum", query: { mode: mode, mainid : mainid,id: data.Doc_MC_Addendum_Id, type: this.$TypeMC.MC100  } });
                }
              
            }
            else if(data.Doc_Type == this.$TypeDocument.DELAY){
                this.$router.push({ path: "/BaDelay/Editor", query: { mode: mode, mainid : mainid,id: data.BA_Delay_Id } });
            }
            else if(data.Doc_Type == this.$TypeDocument.PENALTY){
                this.$router.push({ path: "/BaPenalty/Editor", query: { mode: mode, mainid : mainid,id: data.BA_Penalty_Id } });
            }
            else if(data.Doc_Type == this.$TypeDocument.ADDENDUM){
                this.$router.push({ path: "/BaAddendum/Editor", query: { mode: mode, mainid : mainid,id: data.BA_Addendum_Id } });
            }
            else if(data.Doc_Type == this.$TypeDocument.KOM_QC){
                this.$router.push({ path: "/DocKomQc/Editor", query: { mode: mode, mainid : mainid, id: data.Doc_KOM_QC_Id } });
            }
            else if(data.Doc_Type == this.$TypeDocument.BAST_TERMIN){
                this.$router.push({ path: "/BaTermin/Editor", query: { mode: mode, mainid : mainid,id: data.BA_ST_Termin_Id } });
            }
            else if(data.Doc_Type == this.$TypeDocument.FINAL_QC){
                this.$router.push({ path: "/QcFinal/Editor", query: { mode: mode, mainid : mainid,id: data.QC_Final_Id } });
            }
            else if(data.Doc_Type == this.$TypeDocument.BAST_FINAL){
                this.$router.push({ path: "/BaFinal/Editor", query: { mode: mode, mainid : mainid,id: data.BA_ST_Final_Id } });
            }
            else if(data.Doc_Type == this.$TypeDocument.PROGRESS_FINAL){
                this.$router.push({ path: "/ProgressFinal/Editor", query: { mode: mode, mainid : mainid,id: data.Doc_Progress_Final_Id } });
            }
            else if(data.Doc_Type == this.$TypeDocument.BA_IK_WITHOUT_SPO){
                this.$router.push({ path: "/BaWithOutSpo/Editor", query: { mode: mode, mainid : mainid,id: data.BAIK_WithOut_SPO_Id } });
            }
            else if(data.Doc_Type == this.$TypeDocument.BAST_RETENSI){
                this.$router.push({ path: "/BaRetensi/Editor", query: { mode: mode, mainid : mainid,id: data.BA_ST_Retensi_Id } });
            }
        },  
        gotoCreate(data, mode, mainid, id)
        {
            if(data.Doc_Type == this.$TypeDocument.MC0)
            {
                this.$router.push({ path: "/MC/Editor", query: { mode: mode, mainid : mainid,id: id, type: this.$TypeMC.MC0 }});
            }else if(data.Doc_Type == this.$TypeDocument.ADDENDUM_MC0)
            {
                this.$router.push({ path: "/AddendumMC/EditorBAPVA", query: { mode: mode, mainid : mainid,id: id, type: this.$TypeMC.MC0 } });
            }
            else if(data.Doc_Type == this.$TypeDocument.BA_IK_WITH_SPO)
                this.$router.push({ path: "/BaWithSpo/Editor", query: { mode: mode, mainid : mainid,id: id } });
            else if(data.Doc_Type == this.$TypeDocument.KOM)
                this.$router.push({ path: "/DocKom/Editor", query: { mode: mode, mainid : mainid,id: id } });
            else if(data.Doc_Type == this.$TypeDocument.PROGRESS_TERMIN)
            {
                this.$router.push({ path: "/ProgressTermin/Editor", query: { mode: mode, mainid : mainid,id: id } });
            }
            else if(data.Doc_Type == this.$TypeDocument.MC_BETWEEN)
            {
                this.$router.push({ path: "/MC/Editor", query: { mode: mode, mainid : mainid,id: id, type: this.$TypeMC.MC_BETWEEN }});
            }
            else if(data.Doc_Type == this.$TypeDocument.ADDENDUM_MC_BETWEEN)
            {
                this.$router.push({ path: "/AddendumMC/EditorBAPVA", query: { mode: mode, mainid : mainid,id: id, type: this.$TypeMC.MC_BETWEEN } });
            }
            else if(data.Doc_Type == this.$TypeDocument.MC100)
            {
                this.$router.push({ path: "/MC/Editor", query: { mode: mode, mainid : mainid,id: id, type: this.$TypeMC.MC100 }});
            }else if(data.Doc_Type == this.$TypeDocument.ADDENDUM_MC100)
            {
                this.$router.push({ path: "/AddendumMC/EditorBAPVA", query: { mode: mode, mainid : mainid,id: id, type: this.$TypeMC.MC100 } });
            }
            else if(data.Doc_Type == this.$TypeDocument.DELAY)
                this.$router.push({ path: "/BaDelay/Editor", query: { mode: mode, mainid : mainid,id: id } });
            else if(data.Doc_Type == this.$TypeDocument.PENALTY)
                this.$router.push({ path: "/BaPenalty/Editor", query: { mode: mode, mainid : mainid,id: id } });
            else if(data.Doc_Type == this.$TypeDocument.PROGRESS_FINAL)
            {
                this.$router.push({ path: "/ProgressFinal/Editor", query: { mode: mode, mainid : mainid,id: id } });
            }
            else if(data.Doc_Type == this.$TypeDocument.ADDENDUM)
                this.$router.push({ path: "/BaAddendum/Editor", query: { mode: mode, mainid : mainid,id: id } });
            else if(data.Doc_Type == this.$TypeDocument.KOM_QC)
                this.$router.push({ path: "/DocKomQc/Editor", query: { mode: mode, mainid : mainid,id: id } });
            else if(data.Doc_Type == this.$TypeDocument.BAST_TERMIN)
                this.$router.push({ path: "/BaTermin/Editor", query: { mode: mode, mainid : mainid,id: id } });
            else if(data.Doc_Type == this.$TypeDocument.FINAL_QC)
                this.$router.push({ path: "/QcFinal/Editor", query: { mode: mode, mainid : mainid,id: id } });
            else if(data.Doc_Type == this.$TypeDocument.BAST_FINAL)
                this.$router.push({ path: "/BaFinal/Editor", query: { mode: mode, mainid : mainid,id: id } });
            else if(data.Doc_Type == this.$TypeDocument.BA_IK_WITHOUT_SPO)
                this.$router.push({ path: "/BaWithOutSpo/Editor", query: { mode: mode, mainid : mainid,id: id } });
            else if(data.Doc_Type == this.$TypeDocument.BAST_RETENSI)
                this.$router.push({ path: "/BaRetensi/Editor", query: { mode: mode, mainid : mainid,id: id } });
            
        },  
        generatePdf(data, type){
            if(data.Doc_Type == this.$TypeDocument.MC || data.Doc_Type == this.$TypeDocument.MC0 || data.Doc_Type == this.$TypeDocument.MC_REV || data.Doc_Type == this.$TypeDocument.MC0_REV)
                this.$router.push({ path: "/Print/ShowPrintMC", query: { id: data.Doc_MC_Id} });
            else if(data.Doc_Type == this.$TypeDocument.MC || data.Doc_Type == this.$TypeDocument.MC_BETWEEN || data.Doc_Type == this.$TypeDocument.MC_REV || data.Doc_Type == this.$TypeDocument.MC_BETWEEN_REV)
                this.$router.push({ path: "/Print/ShowPrintMC", query: { id: data.Doc_MC_Id} });
            else if(data.Doc_Type == this.$TypeDocument.MC || data.Doc_Type == this.$TypeDocument.MC100 || data.Doc_Type == this.$TypeDocument.MC_REV || data.Doc_Type == this.$TypeDocument.MC100_REV)
                this.$router.push({ path: "/Print/ShowPrintMC", query: { id: data.Doc_MC_Id} });
           else if(data.Doc_Type == this.$TypeDocument.ADDENDUM_MC0)
           {
                if(type == 'BAPVA')
                {
                    this.$router.push({ path: "/Print/ShowPrintBAPVA", query: { id: data.Doc_BAPVA_Id} });
                }else if(type == 'RKTK')
                {
                    this.$router.push({ path: "/Print/ShowPrintRKTK", query: { id: data.Doc_RKTK_Id} });
                }
                else if(type == 'ADDENDUM')
                {
                    this.$router.push({ path: "/Print/ShowPrintMCAddendum", query: { id: data.Doc_MC_Addendum_Id} });
                }    
           }

            else if(data.Doc_Type == this.$TypeDocument.ADDENDUM_MC_BETWEEN)
            {
                if(type == 'BAPVA')
                {
                    this.$router.push({ path: "/Print/ShowPrintBAPVA", query: { id: data.Doc_BAPVA_Id} });
                }else if(type == 'RKTK')
                {
                    this.$router.push({ path: "/Print/ShowPrintRKTK", query: { id: data.Doc_RKTK_Id} });
                }
                else if(type == 'ADDENDUM')
                {
                    this.$router.push({ path: "/Print/ShowPrintMCAddendum", query: { id: data.Doc_MC_Addendum_Id} });
                }    
            }
            else if(data.Doc_Type == this.$TypeDocument.ADDENDUM_MC100)
            {
                if(type == 'BAPVA')
                {
                    this.$router.push({ path: "/Print/ShowPrintBAPVA", query: { id: data.Doc_BAPVA_Id} });
                }else if(type == 'RKTK')
                {
                    this.$router.push({ path: "/Print/ShowPrintRKTK", query: { id: data.Doc_RKTK_Id} });
                }
                else if(type == 'ADDENDUM')
                {
                    this.$router.push({ path: "/Print/ShowPrintMCAddendum", query: { id: data.Doc_MC_Addendum_Id} });
                }   
            }
            else if(data.Doc_Type == this.$TypeDocument.PROGRESS_TERMIN)
                this.$router.push({ path: "/Print/ShowPrintProgressTermin", query: { id: data.Doc_Progress_Termin_Id} });
            else if(data.Doc_Type == this.$TypeDocument.PROGRESS_FINAL)
                this.$router.push({ path: "/Print/ShowPrintProgressFinal", query: { id: data.Doc_Progress_Final_Id} });
            else if(data.Doc_Type == this.$TypeDocument.BA_IK_WITH_SPO)
                this.$router.push({ path: "/Print/ShowPrintBAIK", query: {id: data.BAIK_With_SPO_Id } });
            else if(data.Doc_Type == this.$TypeDocument.KOM)
                 this.$router.push({ path: "/Print/ShowPrintKOM", query: { id: data.Doc_KOM_Id } });
            else if(data.Doc_Type == this.$TypeDocument.DELAY)
                this.$router.push({ path: "/Print/ShowPrintDelay", query: {id: data.BA_Delay_Id  } });
            else if(data.Doc_Type == this.$TypeDocument.PENALTY)
                this.$router.push({ path: "/Print/ShowPrintPenalty", query: { id: data.BA_Penalty_Id } });
            else if(data.Doc_Type == this.$TypeDocument.ADDENDUM)
                this.$router.push({ path: "/Print/ShowPrintAddendum", query: { id: data.BA_Addendum_Id} });
            else if(data.Doc_Type == this.$TypeDocument.BAST_TERMIN)
                this.$router.push({ path: "/Print/ShowPrintTermin", query: {id: data.BA_ST_Termin_Id } });
            else if(data.Doc_Type == this.$TypeDocument.FINAL_QC)
                this.$router.push({ path: "/Print/ShowPrintQcFinal", query: { id: data.QC_Final_Id } });
            else if(data.Doc_Type == this.$TypeDocument.BAST_FINAL)
                this.$router.push({ path: "/Print/ShowPrintBaFinal", query: { id: data.BA_ST_Final_Id } });
            else if(data.Doc_Type == this.$TypeDocument.BA_IK_WITHOUT_SPO)
                this.$router.push({ path: "/Print/ShowPrintWithoutSPO", query: { id: data.BAIK_WithOut_SPO_Id } });
            else if(data.Doc_Type == this.$TypeDocument.BAST_RETENSI)
                this.$router.push({ path: "/Print/ShowPrintRetensi", query: { id: data.BA_ST_Retensi_Id } });

            
        },
        setFilters() {
            this.filters = {};
            var exportable = this.$refs.dt.columns.filter(c => c.props.field);
            for (var i = 0; i < exportable.length; i++) {
                var filterValue = null;
                if (this.stateFilters) {
                    var field = this.stateFilters[exportable[i].props.field];
                    if (field) filterValue = field.value;
                }
                this.filters[exportable[i].props.field] = { value: filterValue, matchMode: "contains" };
            }
        },
        onStateRestore(event) {
            this.start = event.first;
            this.pageSize = event.rows;
            this.stateFilters = event.filters;
            this.sorts = event.multiSortMeta;
        },
        onModalClose() {
            this.loadLazyData();
        },
        clearFilter() {
            this.filters = {};
            var exportable = this.$refs.dt.columns.filter(c => c.props.field);
            for (var i = 0; i < exportable.length; i++) {
                var fieldName = exportable[i].props.field;
                var filterValue = "";
                if (fieldName.includes("Date")) {
                    filterValue = null;
                }
                this.filters[exportable[i].props.field] = { value: filterValue, matchMode: "contains" };
            }
            this.loadLazyData();
        },
        importFile() {
            this.$router.push({ path: this.uploadPath });
        },
    },
    mounted() {
        this.$emit('unblock-ui');
        this.setFilters();
        this.loadLazyData();
        this.$showToast();

        this.isContractor=  this.$store.getters.getIsContractor;
        this.listTransactionCreate =  this.$store.getters.getListTransactionCreate;
        this.listTransactionEdit =  this.$store.getters.getListTransactionEdit;
        this.listTransactionView =  this.$store.getters.getListTransactionView;
        this.listTransactionPrint =  this.$store.getters.getListTransactionPrint;
        this.canViewRKTK = this.listTransactionView.includes('RKTK');
        this.canEditRKTK = this.listTransactionEdit.includes('RKTK');
        this.canPrintRKTK = this.listTransactionPrint.includes('RKTK');
        this.canViewAddendum = this.listTransactionView.includes('ADDENDUMMC');
        this.canEditAddendum = this.listTransactionEdit.includes('ADDENDUMMC');
        this.canPrintAddendum = this.listTransactionPrint.includes('ADDENDUMMC');
        this.canEditBAPVA = this.listTransactionEdit.includes('ADDENDUM MC0','ADDENDUM MC BETWEEN','ADDENDUM MC100');
        this.canPrintBAPVA = this.listTransactionPrint.includes('ADDENDUM MC0','ADDENDUM MC BETWEEN','ADDENDUM MC100');
    },
    computed: {
        dataFilter() {
            var h = [];
            if (this.filters) {
                for (const [key, value] of Object.entries(this.filters)) {
                    h.push({
                        field: key ? key : null,
                        value: value.value,
                        matchMode: value.matchMode
                    });
                }
            }
            return h;
        },
        dataSort() {
            var h = [];
            if (this.sorts) {
                for (var x = 0; x < this.sorts.length; x++) {
                    h.push({
                        field: this.sorts[x].field,
                        order: this.sorts[x].order == 1 ? "ASC" : "DESC"
                    });
                }
            }
            return h;
        },
        filterBadge() {
            var badgeNumber = 0;

            this.dataFilter.filter(function (item) {
                if (item.value && item.field != "Status") {
                    badgeNumber++;
                }
            });

            return badgeNumber;
        }
    },
}
</script>

<style>
.p-card .p-card-content {
    margin: 0 !important;
    padding: 0 !important;
}
</style>

<!-- .p-confirm-popup {
  
    box-shadow: 0px 11px 15px -7px rgb(188, 184, 184), 0px 24px 38px 3px red, 0px 9px 46px 8px red;
} -->